import { render, staticRenderFns } from "./SetGalleryModal.vue?vue&type=template&id=6c17258a&scoped=true&"
import script from "./SetGalleryModal.vue?vue&type=script&lang=js&"
export * from "./SetGalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17258a",
  null
  
)

export default component.exports